import AdminStudentAdd from '@/pages/admin/student/Add'
import AdminStudentEdit from '@/pages/admin/student/Edit'

export default [
  {
    path: '/admin/student/add',
    name: 'AdminStudentAdd',
    component: AdminStudentAdd,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Добавление аттестуемого'
    }
  },
  {
    path: '/admin/student/edit/:id',
    name: 'AdminStudentEdit',
    props: true,
    component: AdminStudentEdit,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Редактирование аттестуемого'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/student.js